export default 'https://tme.understood.org/assets/price_tag.3e4afcdf.bin'